/**
 * @file: appdist.service.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { HttpClient } from '@euler/lib/request';
import { AppVersion, AppVersionDetail } from '@euler/model';

export class AppDistService {
  constructor(private readonly api: HttpClient) {}

  async getAppVersionHistory(params: {
    name: string;
    platform: 'ios' | 'android' | 'web';
    env: 'development' | 'test' | 'production';
    limit?: number;
  }): Promise<AppVersion[]> {
    return await this.api.get().url('/appdist/versions', params).future();
  }

  async getVersionDetail(params: {
    name: string;
    platform: 'ios' | 'android' | 'web';
    env: 'development' | 'test' | 'production';
    version: string;
    prerelease?: boolean;
  }): Promise<AppVersionDetail> {
    return await this.api
      .get()
      .url('/appdist/versions/:version/detail', params)
      .future();
  }
}
